import { ArrowUpRight } from "lucide-react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { projectVisuals } from '../../data/courseSectionVisuals';

export const ProjectsSection = ({ projects, landing }) => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.2 });

  if (!projects || projects.length === 0) return null;

  return (
    <section
      id="course-projects"
      ref={sectionRef}
      className="py-20 bg-gray-50"
      data-testid="projects-section"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className={`text-center mb-12 transition-all duration-300 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}>
          <span className="course-eyebrow">
            Практика
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <span className="ink-underline">{landing?.projectHeading || 'Проекты из программы'}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {projects.map((project, idx) => {
            const visual = projectVisuals[project.url];
            const detail = landing?.projects[project.url];
            return (
            <a
              key={idx}
              href={visual?.href || project.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`project-card-${idx}`}
              className={`course-project-card group flex flex-col bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-lg hover:border-teal-200 hover:-translate-y-1 transition-all duration-300 ease-out ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${idx * 120 + 200}ms` }}
            >
              {visual && <div className={`course-project-preview ${landing && visual.mobile ? 'course-project-preview-devices' : ''}`}><img src={visual.src} alt={visual.alt} width="1440" height="810" loading="lazy" decoding="async" />{landing && visual.mobile && <img className="course-project-mobile" src={visual.mobile} alt="Мобильная версия сайта-портфолио" width="390" height="844" loading="lazy" decoding="async"/>}</div>}
              <div className="course-project-copy">
              {visual && !landing && <p className="course-project-caption">{visual.caption}</p>}
              <h3 className="text-lg font-bold text-gray-900 mb-2">{project.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{detail?.description || project.description}</p>
              <span className="course-project-action">{visual?.action || 'Открыть проект'}<ArrowUpRight size={18} aria-hidden="true" /></span>
              </div>
            </a>
          );})}
        </div>
      </div>
    </section>
  );
};
